export const ErrorCodes = {
    STORAGE_LIMIT_REACHED : "asset.storage.limit_exceeded",
  }